import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlService } from '../state/url.service';

@Injectable({
  providedIn: 'root'
})
export class ReferrerService {
  private readonly urlService = inject(UrlService);

  public static readonly URL_PARAM_REF = 'beruferef';
  public berufeRef$ = this.urlService.getQueryParameterValue(ReferrerService.URL_PARAM_REF);
  public origin$: Observable<'NEWPLAN' | 'BNET' | ''> = this.berufeRef$.pipe(
    map((reference) => {
      if (reference?.startsWith('berufenet')) {
        return 'BNET';
      } else if (reference?.startsWith('new-plan') || reference?.startsWith('sete')) {
        return 'NEWPLAN';
      } else {
        return '';
      }
    })
  );
}
